import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import WhatWeDo from './components/WhatWeDo';
import Features from './components/Features';
import Integrations from './components/Integrations';
import Industries from './components/Industries';
import CTA from './components/CTA';
import Footer from './components/Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <WhatWeDo />
      <Features />
      <Integrations />
      <Industries />
      <CTA />
      <Footer />
    </div>
  );
};

export default LandingPage;
